var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3308 8.65222L12.0197 5.34103M2.5 18.1719L5.30156 17.8606C5.64385 17.8226 5.81499 17.8035 5.97496 17.7518C6.11688 17.7058 6.25194 17.6409 6.37647 17.5588C6.51684 17.4662 6.6386 17.3445 6.88212 17.1009L17.8142 6.16883C18.7286 5.25447 18.7286 3.772 17.8142 2.85764C16.8999 1.94329 15.4174 1.94329 14.5031 2.85764L3.57094 13.7897C3.32742 14.0333 3.20566 14.155 3.1131 14.2954C3.03097 14.4199 2.96606 14.555 2.92012 14.6969C2.86833 14.8569 2.84932 15.028 2.81128 15.3703L2.5 18.1719Z",
    stroke: "#1997F5",
    strokeWidth: 1.65559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditGreen);
export default __webpack_public_path__ + "static/media/icon-edit-green.b62a24e6.svg";
export { ForwardRef as ReactComponent };